<template>
    <ul class="list-group mb-3 z-depth-1">
        <li class="list-group-item d-flex justify-content-between">
            <div class="row">
                <div class="col-12 d-flex justify-content-center align-items-center">
                    <h4>
                        <span class="text-muted font-weight-normal">
                            {{ $t('Booking details') }}
                        </span>
                    </h4>
                </div>
            </div>
        </li>
        <li v-if="rentPrice" class="list-group-item">
            <div class="d-flex justify-content-between">
                <h6 class="my-0">
                    {{ vehicle.make.name }} {{ vehicle.model.name }}
                </h6>
                <span class="text-muted text-nowrap">{{ (vehicle.all_prices.sub_total / 100).toFixed(2) }} EUR</span>
            </div>
            <div class="d-flex justify-content-between">
                <p class="dark-grey-text p-300-xs mb-0">
                    {{ vehicle.all_prices.days }} {{ $t(vehicle.all_prices.days > 1 ? 'days' : 'day') }} x {{ (vehicle.all_prices.day_price / 100).toFixed(2) }}
                </p>
                <p class="dark-grey-text p-300-xs mb-0">
                    {{ (vehicle.all_prices.days * vehicle.all_prices.day_price / 100).toFixed(2) }} EUR
                </p>
            </div>
            <div v-if="vehicle.all_prices.over_hrs" class="d-flex justify-content-between">
                <p class="dark-grey-text p-300-xs mb-0">
                    {{ vehicle.all_prices.over_hrs }} {{ $t(vehicle.all_prices.over_hrs > 1 ? 'hours' : 'hour') }} x {{ (vehicle.all_prices.hr_price / 100).toFixed(2) }}
                </p>
                <p class="dark-grey-text p-300-xs mb-0">
                    {{ (vehicle.all_prices.added_price / 100).toFixed(2) }} EUR
                </p>
            </div>
        </li>
        <li class="list-group-item d-flex justify-content-between">
            <div>
                <p class="my-0 p-300-sm">
                    {{ $t('Pick up date and location') }}
                </p>
                <p class="dark-grey-text p-300-xs">
                    {{ search_dates[0] }} {{ start_time }},
                    {{ locationName(pickup_location_id) }}
                </p>
                <p class="my-0 p-300-sm">
                    {{ $t('Return date and location') }}
                </p>
                <p class="dark-grey-text p-300-xs mb-0">
                    {{ search_dates[1] }} {{ end_time }},
                    {{ locationName(return_location_id) }}
                </p>
            </div>
        </li>
        <li v-if="additional_eqs.length" class="list-group-item d-flex justify-content-between">
            <div>
                <h6 class="my-0">{{ $t('Additional equipment') }}</h6>
                <p v-for="(eq, i) in additional_eqs" :key="i" class="dark-grey-text p-300-sm mb-0">
                    {{ eq.name[locale] }}
                </p>
            </div>
            <span class="text-muted" style="white-space: nowrap;">
                {{ ((totalAddEqPrice + totalAddEqAddedPrice) / 100).toFixed(2) }} EUR
            </span>
        </li>
        <li v-if="paid_services.length" class="list-group-item d-flex justify-content-between">
            <div>
                <h6 class="my-0">{{ $t('Paid services') }}</h6>
                <p v-for="(serv, i) in paid_services" :key="i" class="dark-grey-text p-300-sm mb-0">
                    {{ serv.name[locale] }}
                </p>
            </div>
            <span class="text-muted" style="white-space: nowrap;">
                {{ totalServPrice / 100 }} EUR
            </span>
        </li>
        <li v-if="discount && discountFromFullPrice" class="list-group-item d-flex justify-content-between bg-info-light">
            <div class="white-text font-weight-normal">
                <h6 class="my-0" v-if="promocode_id">
                    {{ $t('Promocode') }}
                </h6>
                <h6 class="my-0" v-else>{{ $t('Discount') }}</h6>
            </div>
            <span class="white-text font-weight-normal">
                -{{ discount }} %
                <template v-if="vehicle.all_prices.has_discount">
                    <small>({{ $t('from full price') }} {{ ((vehicle.all_prices.full_price + totalAddEqPrice) / 100).toFixed(2) }} EUR)</small>
                </template>
            </span>
        </li>
        <li class="list-group-item d-flex justify-content-between">
            <span class="font-weight-normal">{{ $t('Total price') }}</span>
            <strong>{{ (totalPrice / 100).toFixed(2) }} EUR</strong>
        </li>
    </ul>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: 'BookingDetails',
    props: {
        promocode_id: Number,
        totalPrice: Number,
        rentPrice: Number,
        totalServPrice: Number,
        totalAddEqPrice: Number,
        totalAddEqAddedPrice: Number,
        discountFromFullPrice: Boolean,
        discount: Number,
        vehicle: Object,
        additional_eqs: Array,
        paid_services: Array,
        search_dates: Array,
        locations: Array,
        start_time: String,
        end_time: String,
        pickup_location_id: Number,
        return_location_id: Number,
    },
    computed: {
        ...mapGetters(['locale'])
    },
    methods: {
        locationName(locationId) {
            return this.locations.some(l => l.id === locationId)
                ? this.locations.find(l => l.id === locationId).name[this.locale]
                : null;
        },
    }
};
</script>
